import { render, staticRenderFns } from "./DrawPopup.vue?vue&type=template&id=99add2f2&scoped=true&"
import script from "./DrawPopup.vue?vue&type=script&lang=js&"
export * from "./DrawPopup.vue?vue&type=script&lang=js&"
import style0 from "./DrawPopup.vue?vue&type=style&index=0&id=99add2f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99add2f2",
  null
  
)

export default component.exports